module.exports = __webpack_public_path__ + "assets/img/third_pay_page_default_style.b2c340f.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/third_pay_page_default_style.png
// module id = L8+Q
// module chunks = 50